import { Component, EventEmitter, Input, OnInit, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';

@Component({
  selector: 'app-formfield',
  templateUrl: './formfield.component.html',
  styleUrls: ['./formfield.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class FormfieldComponent implements OnInit {

  @Input() placeholder!: string;
  @Input() name!: string;
  @Input() type = 'text';
  @Input() myForm!: NgForm;

  @Input() label = true;
  @Input() disabled = false;

  @Input() required = false;

  @Input() model!: any;
  @Output() modelChange = new EventEmitter<any>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onModelChange = new EventEmitter<any>();

  @Input() mask = ''
  @Input() separator = '.'
  @Input() suffix = '€'

  @Input() decimalMarker: any = ','
  @Input() pattern = ''

  constructor() { }

  ngOnInit(): void {
  }

  eventChange(event: string): void {
    let value = event ? event.toString() : '';
    if (this.mask !== '' && event) {
      // value = value.replace(/\D/g, '');
      // value = value.replace(/[^0-9,]/g, '');
    }
    this.modelChange.emit(value);
    this.onModelChange.emit(value);
  }

}
